// Libs
import React, { ReactElement } from 'react';
import { NextSeo } from 'next-seo';
// UI components
import { Typography } from 'ui-components';
// App
import { ContentCard } from 'app-shared/lib/components/cards/content-card';
import styles from './page.module.scss';
import { AuthConfig } from '@/fragments/auth';

const MaintenancePage = (): ReactElement => {
  return (
    <>
      <NextSeo noindex={true} />
      <ContentCard className={styles.container}>
        <Typography variant="body1" align="center">
          🚧 circlee.fr est en maintenance ! 😊 <br /> Encore un peu de patience et le site sera de nouveau disponible
          avec de nouvelles fonctionnalités et mises à jour 🎉
        </Typography>
      </ContentCard>
    </>
  );
};

const authConfig: AuthConfig = {
  restrictedAccess: false,
};

MaintenancePage.authConfig = authConfig;

export default MaintenancePage;
